import React, { useState, useEffect } from "react";
import {
  is_shop_admin,
  is_shop_manager,
  is_back_office,
} from "../../../Functionalities/Config";
import { ManageProducts, showMessage } from "../../../Functionalities/Functions";
import { ManageInnerCategory } from "../../Menu/Logic";
import SaleFields from "./SaleFields";
import { saleDiscountError } from "../sale";

function ProductEditForm({ data, setData, setEdit, getData, setErrors, catData }) {
  const [localMenus, setLocalMenus] = useState([]);

  useEffect(() => {
    if (!catData || catData.length === 0) {
      fetchMenus();
    }
  }, [catData]);

  const fetchMenus = async () => {
    let params = "for_dropdown=true&is_dropdown=true&page_wise=false&order_by_name=true";
    let result = await ManageInnerCategory("", "", "get", params);
    const list = Array.isArray(result?.data)
      ? result.data
      : (Array.isArray(result?.data?.results)
          ? result.data.results
          : (Array.isArray(result?.data?.data) ? result.data.data : []));
    setLocalMenus(list);
  };

  const menus = Array.isArray(catData) && catData.length > 0 ? catData : localMenus;

  return (
    <div className="col-xl-12 col-lg-12">
      <div className="card">
        <div className="card-body">
          <div className="basic-form">
            <form>
              {is_back_office && (
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Branch : </label>
                  <div className="col-sm-9">
                    <input
                      value={data.branch.name}
                      className="form-control form-control-lg"
                      disabled
                    />
                  </div>
                </div>
              )}
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Product name<span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={data.name}
                    onChange={(e) => setData({ ...data, name: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Category<span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <select
                    className="form-control"
                    value={
                      data.inner_category1
                        ? data.inner_category1
                        : (Array.isArray(data.inner_category) && data.inner_category.length > 0
                            ? (typeof data.inner_category[0] === "object" && data.inner_category[0] !== null
                                ? data.inner_category[0].id
                                : data.inner_category[0])
                            : "")
                    }
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const menuList = Array.isArray(menus) ? menus : [];
                      const selectedObj = menuList.find(
                        (m) => String(m.id) === String(selectedId)
                      );
                      setData({
                        ...data,
                        inner_category1: selectedId,
                        inner_category: selectedObj
                          ? [selectedObj]
                          : (selectedId ? [{ id: selectedId, name: "" }] : []),
                      });
                    }}
                  >
                    <option value="">---Select Category---</option>
                    {(Array.isArray(menus) ? menus : []).map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {!is_shop_admin && !is_shop_manager && (
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">
                    Product commission
                    <i
                      style={{ cursor: "pointer" }}
                      className="ml-1 fs-20 fa fa-info-circle"
                      title="set blank to disable product commission, set 0 to do not take commission for the product, set other number to take specified commission for that product"
                    ></i>
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="number"
                      onKeyDown={(evt) =>
                        ((evt.key === "e" || evt.key === "-") &&
                          evt.preventDefault()) ||
                        (evt.key === "E" && evt.preventDefault())
                      }
                      onWheelCapture={(e) => {
                        e.target.blur();
                      }}
                      className="form-control"
                      value={data.product_commission}
                      onChange={(e) =>
                        e.target.value >= 100
                          ? showMessage(
                              "Commission should be less than 100",
                              "danger",
                              "Error!",
                              "top",
                              "top-right",
                              0
                            )
                          : setData({
                              ...data,
                              product_commission: e.target.value,
                            })
                      }
                    />
                  </div>
                </div>
              )}

              <SaleFields data={data} setData={setData} rate={data.varients?.[0]?.rate} />

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description</label>
                <div className="col-sm-9">
                  <textarea
                    className="form-control"
                    rows="4"
                    id="comment"
                    value={data.description}
                    onChange={(e) =>
                      setData({ ...data, description: e.target.value })
                    }
                  ></textarea>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">is new : </label>
                <div className="col-sm-9" style={{ marginTop: -15 }}>
                  <div className="col-sm-6">
                    <div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={data.is_new}
                        onChange={(e) => {
                          setData({
                            ...data,
                            is_new: e.target.checked,
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <label className="form-check-label">{""}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">is popular : </label>
                <div className="col-sm-9" style={{ marginTop: -15 }}>
                  <div className="col-sm-6">
                    <div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={data.is_popular}
                        onChange={(e) => {
                          setData({
                            ...data,
                            is_popular: e.target.checked,
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <label className="form-check-label">{""}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">is recommended : </label>
                <div className="col-sm-9" style={{ marginTop: -15 }}>
                  <div className="col-sm-6">
                    <div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={data.is_recommended}
                        onChange={(e) => {
                          setData({
                            ...data,
                            is_recommended: e.target.checked,
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <label className="form-check-label">{""}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">is bundle : </label>
                <div className="col-sm-9" style={{ marginTop: -15 }}>
                  <div className="col-sm-6">
                    <div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={data.is_bundle}
                        onChange={(e) => {
                          setData({
                            ...data,
                            is_bundle: e.target.checked,
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <label className="form-check-label">{""}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">is trending : </label>
                <div className="col-sm-9" style={{ marginTop: -15 }}>
                  <div className="col-sm-6">
                    <div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={data.is_trending}
                        onChange={(e) => {
                          setData({
                            ...data,
                            is_trending: e.target.checked,
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <label className="form-check-label">{""}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">occasion tag : </label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="text"
                    value={data.occasion_tag}
                    onChange={(e) => {
                      setData({
                        ...data,
                        occasion_tag: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Out of stock : </label>
                <div className="col-sm-9" style={{ marginTop: -15 }}>
                  <div className="col-sm-6">
                    <div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={data.is_out_of_stock}
                        onChange={(e) => {
                          setData({
                            ...data,
                            is_out_of_stock: e.target.checked,
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <label className="form-check-label">
                        {"Tick for out of stock"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div className="form-group row">
                <div className="col-sm-10 text-right">
                  <button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      setEdit(false);
                    }}
                    className="btn btn-danger mr-2"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      setErrors([]);
                      if (data.name === "") {
                        setErrors((prev) => [...prev, "name"]);
                        return;
                      }
                      if (!data.inner_category1 && (!data.inner_category || data.inner_category.length === 0)) {
                        setErrors((prev) => [...prev, "Category"]);
                        return;
                      }

                      const saleError = saleDiscountError(data);
                      if (saleError) {
                        showMessage(saleError, "danger", "Error!", "top", "top-right", 0);
                        return;
                      }

                      const result = ManageProducts(e, data, "update", "");
                      result
                        .then((res) => {
                          if (res.data.Status === true) {
                            setEdit(false);
                            getData();
                            showMessage(
                              "Product updated",
                              "success",
                              "success!",
                              "top",
                              "top-right",
                              0
                            );
                          } else {
                            showMessage(
                              res.data.Error,
                              "danger",
                              "Error!",
                              "top",
                              "top-right",
                              0
                            );
                          }
                        })
                        .catch((err) => err);
                    }}
                    className="btn btn-primary"
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductEditForm;
